import { app } from '../../../../app';
import { Controller } from './shared-passwords.controller';

app.component('companySharingCenterSharedPasswords', {
    bindings: {
        companyId: '<',
        accounts: '<',
        allAccounts: '<',
        publicServicesWithSso$: '<',
    },
    controller: Controller,
    templateUrl: require('./shared-passwords.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/shared-passwords.component.js